import { ERROR_MESSAGES, PUSHER_ERROR_CODES } from '../../constants/pusher';

export type PusherRuntimeError = {
  errorCode: number;
  message: string;
};

export const getPusherUnavailableError = (): PusherRuntimeError => ({
  errorCode: PUSHER_ERROR_CODES.SDK_NOT_AVAILABLE,
  message: ERROR_MESSAGES[PUSHER_ERROR_CODES.SDK_NOT_AVAILABLE],
});

export const getTXLivePusherConstructor = (
  targetWindow: Partial<Window & typeof globalThis> = window
): typeof TXLivePusher | null => {
  const ctor = targetWindow.TXLivePusher;
  return typeof ctor === 'function' ? ctor : null;
};
